module.exports = __webpack_public_path__ + "img/xof.71caec3e.svg";